import React from 'react';
//import * as ReactDOM from 'react-dom';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { LookAugmentRealityIcon } from "../../../common/icons";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";
import Button from "@mui/material/Button";
import WebXRGoogleModelViewer from "./WebXRGoogleModelViewer";

const ARButtonGoogleWebXR = (props) => {
  const { url } = props;

  const activateAR = () => {
    const modelViewer = document.querySelector('#arViewer');
    if (modelViewer) {
      modelViewer.activateAR();
    }
  };

  return (
    <div>
      <WebXRGoogleModelViewer props url={url}/>
      <Button className="ar-popup__link" onClick={activateAR}>
        <SvgIcon>
          <LookAugmentRealityIcon />
        </SvgIcon>
        <div>
          <b>AUGMENTED</b> REALITY
        </div>
        <div>
          <small>TAP TO ACTIVATE</small>
        </div>
      </Button>
    </div>
  );
};

ARButtonGoogleWebXR.propTypes = {
  url: PropTypes.string,
};

const mapStateToProps = (store) => {
  return {
    visualizersLoaded: store.serverState.visualizersLoaded,
    cabinetsARBlobUrl: store.sqftState.cabinetsARBlobUrl,
  };
};

const mapDispatchToProps = {};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ARButtonGoogleWebXR)
  )
);
